var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.filterListRoute.includes(_vm.$route.name))?_c('sub-nav',{attrs:{"route-list":_vm.filterList,"project-id":_vm.projectId}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }